import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import {generateFingerprint} from './Footprint';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('activeTab') || 'freeform';
  });

  const [freeformText, setFreeformText] = useState('');
  const [fileType, setFileType] = useState(() => {
    return localStorage.getItem('fileType') || 'js';
  });

  const [status, setStatus] = useState('');
  const [statusColor, setStatusColor] = useState('');
  const [responseUrl, setResponseUrl] = useState('');

  const [loading, setLoading] = useState(true);
  const [uuid, setUUID] = useState('');

  generateFingerprint().then(fp => {
    setUUID(fp);
    setLoading(false);
  });

  useEffect(() => {
    const savedType = localStorage.getItem('fileType') || 'txt';
    const savedText = localStorage.getItem(`freeformText:${savedType}`) || '';
    setFileType(savedType);
    setFreeformText(savedText);
  }, []);

  const switchTab = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('activeTab', tab);
  };

  const handleFreeformBlur = () => {
  localStorage.setItem(`freeformText:${fileType}`, freeformText);
};

const handleFileTypeChange = (e) => {
  const newType = e.target.value;
  setFileType(newType);
  localStorage.setItem('fileType', newType);

  const savedText = localStorage.getItem(`freeformText:${newType}`);
  setFreeformText(savedText || '');
};

  const handleEditorChange = (value) => {
    setFreeformText(value || '');
  };

  const handlePublish = async () => {
    const payload = { type: 'freeform', content: freeformText, fileType, uuid };

    try {
      const response = await fetch('/push', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('✅ Published successfully!');
        setStatusColor('');
        setResponseUrl(result.url || '');
      } else {
        if (response.status === 413) {
          setStatus(`⚠️ ${result.error || 'Upload exceeds 2MB limit.'}`);
          setStatusColor('#b45309');
        } else {
          setStatus(`❌ Error publishing: ${result.error || 'Unknown error'}`);
          setStatusColor('red');
        }
        setResponseUrl('');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('⚠️ Error publishing.');
      setStatusColor('red');
      setResponseUrl('');
    }
  };

  const handleGistKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handlePublish();
    }
  };

  const monacoLanguageMap = {
    js: 'javascript',
    css: 'css',
    html: 'html',
    md: 'markdown',
    txt: 'plaintext',
    json: 'json',
  };

  if (loading) {
    return (
      <div className="container">
        loading...
      </div>
    );
  }

  return (   
    <div className="container">
      <h1>Free Web Host</h1>
      <p>Host basic web files, for free!</p>

      <div className="tabs">
        <button
          className={activeTab === 'freeform' ? 'active' : ''}
          onClick={() => switchTab('freeform')}
        >
          Freeform
        </button>
        <button
          className={activeTab === 'gist' ? 'active' : ''}
          onClick={() => switchTab('gist')}
        >
          Gist
        </button>
      </div>

      <div className="module">
        {activeTab === 'gist' && (
          <>
            <p>This has been deprecated!</p>
          </>
        )}

        {activeTab === 'freeform' && (
          <>
            <p>🧾 Enter any content you'd like to host or share.</p>

            <div className="radio-group">
              {['js', 'css', 'html', 'md', 'txt', 'json'].map((type) => (
                <label key={type}>
                  <input
                    type="radio"
                    name="fileType"
                    value={type}
                    checked={fileType === type}
                    onChange={handleFileTypeChange}
                  />
                  {type}
                </label>
              ))}
            </div>

            <div onBlur={handleFreeformBlur}>
              <Editor
                height="300px"
                language={monacoLanguageMap[fileType]}
                value={freeformText}
                onChange={handleEditorChange}
                theme="vs-dark"
              />
            </div>

            <button onClick={handlePublish}>Publish</button>
            {status && <p style={{ color: statusColor }}>{status}</p>}
            {responseUrl && (
              <a
                className="pill-link"
                href={responseUrl}
                target="_blank"
                rel="noreferrer"
              >
                {responseUrl}
              </a>
            )}
              
          </>
        )}
        
      </div>
    </div>
  );
}

export default App;
